module.exports = __webpack_public_path__ + "04_long_gray.36b9b9b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_long_gray.png
// module id = /y/R
// module chunks = 0